import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { ActivateService } from './activate.service';

@Injectable()
export class ActivateGuardService {
	constructor(
		private readonly activateService: ActivateService,
		private readonly router: Router
	) {}

	canActivate(route: ActivatedRouteSnapshot): boolean {
		if (route.queryParams.key) {
			this.activateService.token = route.queryParams.key;
			return true;
		}
		this.router.navigate(['']).then();
		return false;
	}
}

export const ActivateGuard: CanActivateFn = (route: ActivatedRouteSnapshot): boolean =>
	inject(ActivateGuardService).canActivate(route);
